// 西班牙
module.exports = {
  validate: {
    noEmail: "El correo electrónico no puede estar vacío, vuelva a ingresar",
    noPhone: "El número de teléfono no puede estar vacío, vuelva a ingresarlo",
    errorReg:
      "La longitud de entrada es de 1 a 50 dígitos, puede ingresar letras mayúsculas y minúsculas, números, símbolos - . _ @",
    noPassword: "La contraseña no puede estar vacía, vuelva a ingresarla",
    pwdReg:
      "La longitud de entrada de la contraseña es de 8 a 32 dígitos, solo y debe contener números y letras",
    pwdCheck:
      "Las dos contraseñas ingresadas son inconsistentes, vuelva a ingresar",
    pwdLengthReg:
      "La longitud de la contraseña varía de 8 a 32, confirme la entrada",
    noCode: "por favor ingrese el código de verificación",
    codeReg: "Por favor ingrese un código de verificación de 6 dígitos",
    nullText: "La entrada no puede estar vacía, vuelva a ingresar",
    phoneCheck:
      "El número de teléfono ingresado dos veces es inconsistente, vuelva a ingresarlo",
    emailNumReg:
      "La longitud de entrada del correo electrónico es de 6 a 50 caracteres, vuelva a ingresar",
    emailReg: "Dirección de correo electrónico incorrecta, vuelva a ingresarla",
    emailCheck:
      "La cuenta de correo electrónico ingresada dos veces es inconsistente, vuelva a ingresar",
    noUsername:
      "La contraseña no puede contener el número de cuenta, vuelva a ingresar",
    accountReg:
      "La entrada del nombre de la cuenta es incorrecta, vuelva a ingresarla",
  },
  area: {
    areaTitle: "Gestión de Áreas",
    add: "Agregar área",
    area: "área",
    addNextArea: "Crear una nueva área subordinada",
    areaNameTip: "Por favor ingrese un nombre de región",
    areaNameHold:
      "La longitud de entrada es de 1 a 20 dígitos, no se pueden ingresar símbolos especiales",
    areaNumHold:
      "La longitud de entrada es de 1 a 4 dígitos, solo se pueden ingresar números y el rango de números es de 0 a 9999",
    areaNumTip: "Por favor ingrese el número de área",
    areaName: "Nombre del área",
    checkAreaName: "El nombre del área no puede estar vacío, vuelva a ingresar",
    areaNameTip1: "El nombre del área no puede estar vacío",
    areaNameTip2: "Ingreso de nombre de área incorrecto, vuelva a ingresar",
    areaNum: "Número de área",
    checkAreaNum: "El ID de área no puede estar vacío, vuelva a ingresar",
    lastLevel: "Pertenece al área superior",
    checkLastLevel:
      "El área de nivel superior a la que pertenece no puede estar vacía, seleccione de nuevo",
    lastLevelTip: "Por favor seleccione el área matriz a la que pertenece",
    delInfo:
      "Al ejecutar esta tarea de eliminación, se eliminarán los datos de esta área y no se podrán recuperar",
    oneStep: "nivel uno",
    twoStep: "secundario",
    threeStep: "Nivel 3",
    fourStep: "Nivel 4",
    fiveStep: "Nivel 5",
    delAreaTip: "Hay un área subordinada que no se puede eliminar",
    personArea: "La persona no está ligada al área",
    areaType: "Añadir método",
    addArea1: "Añadir por separado",
    addArea2: "adición continua",
    addArea3: "Suma de matrices",
    areaNameTop: "Prefijo de nombre de zona",
    areaNameLast: "Sufijo de nombre de zona",
    areaJoinHold: "Por favor ingrese el prefijo del nombre de dominio",
    areaJoinHold1: "Ingrese el sufijo del nombre del área",
    startNum: "Número de inicio",
    checkStartNum:
      "La entrada del número inicial es incorrecta, vuelva a ingresarla",
    checkStartNum1:
      "La entrada del número inicial no puede estar vacía, vuelva a ingresar",
    checkEndNum: "La entrada del número final es incorrecta, vuelva a ingresar",
    checkEndNum1: "El número final no puede estar vacío, vuelva a ingresarlo",
    endNum: "Número final",
    topStart: "Número de inicio del encabezado",
    checkTopStart:
      "La entrada del primer número inicial es incorrecta, vuelva a ingresar",
    checkTopStart1:
      "La entrada del primer número inicial no puede estar vacía, vuelva a ingresar",
    topEnd: "Número final del encabezado",
    checkTopEnd:
      "Ingrese el número final del encabezado es incorrecto, vuelva a ingresarlo",
    checkTopEnd1:
      "La entrada del primer número final no puede estar vacía, vuelva a ingresar",
    lastStart: "Número de inicio de cola",
    checkLastStart:
      "La entrada del número de inicio de cola es incorrecta, vuelva a ingresar",
    checkLastStart1:
      "Ingrese el número de inicio de cola no puede estar vacío, vuelva a ingresar",
    lastEnd: "Número de final de ruta",
    checkLastEnd:
      "Ingrese el número final de la cola es incorrecto, vuelva a ingresar",
    checkLastEnd1:
      "La entrada del número final no puede estar vacía, vuelva a ingresar",
    topTip:
      "La longitud de entrada es de 1 a 2 dígitos, solo se pueden ingresar números y el rango de números es de 1 a 99",
    lastTip:
      "La longitud de entrada es de 1 a 2 dígitos, solo se pueden ingresar números y el rango de números es de 1 a 99",
    areaNameTest: "Ejemplo de nombre de área",
  },
  addressBook: {
    config: "Configuración del proyecto",
    errorTip: "Error de formato de la libreta de direcciones",
    upgrade: "Gestión de actualización de la libreta de direcciones",
    deviceIdTip: "Por favor ingrese la identificación del dispositivo",
    deviceId: "ID del dispositivo",
    syncAll: "Sincronizar todo",
    sync: "Sincronizar",
    sysVersion: "Versión actual de la libreta de direcciones del sistema",
    deviceVersion:
      "Versión actual de la libreta de direcciones del dispositivo",
    syncTip: "Emitió con éxito el comando síncrono",
  },
  newarea: {
    add: "Agregar área",
    edit: "Editar Área",
    smallTip:
      "Actualmente el nivel de área más pequeño, no se pueden agregar más subáreas",
    batch: "Agregar lote de área",
    batch1: "adición continua",
    batch2: "Suma de matrices",
  },
  deviceSip: {
    saveTip:
      "Exporte la libreta de direcciones a tiempo; de lo contrario, todos los datos se borrarán después de salir de la página",
    devMsg: "Información del dispositivo",
    list: "Lista de dispositivos",
    add: "Añadir dispositivo",
    edit: "Editar dispositivo",
    batch: "Agregar dispositivos en lotes",
    areaChosen: "Selección de nivel de área",
    areaNum: "Número de dispositivos recién agregados en cada área",
    bacthTip:
      "Cuando el nivel de área se selecciona como un edificio, y la cantidad de dispositivos nuevos en cada área es 4, significa que se agregan 4 dispositivos en cada área creada",
    note: "ilustrar",
    baseConfig: "Configuración de información básica",
    deviceName: "Nombre del dispositivo",
    nameTip:
      "Arreglado para agregar un número al nombre del grupo al que pertenece, por ejemplo, Edificio 1-1",
    function: "Función de soporte de dispositivo",
    net: "Configuración de la red",
    netType: "Tipo de red",
    netTip1:
      "Estática es una red estática, debe configurar manualmente la IP y otra información",
    netTip2:
      "DHCP es una red dinámica y el enrutador asigna automáticamente información como la IP",
    mask: "Por favor ingrese la máscara de subred",
    gateway: "Por favor ingrese la puerta de enlace",
    ip: "Por favor ingrese la dirección IP",
    ipTip:
      "La dirección IP de entrada debe evitar una IP especial, como 127.0.0.1, etc.",
    dns1: "Por favor ingrese DNS1",
    dns2: "Por favor ingrese DNS2",
    sip1: "configuración de información sip1",
    config: "Configuración de la Información",
    mode: "modelo",
    mode1: "Modo Directo",
    mode2: "Modo servidor",
    user: "por favor ingrese el nombre de usuario",
    userTitle: "nombre de usuario",
    userTip:
      "El valor predeterminado es agregar un número al nombre del grupo, como 1-1-1",
    last: "Por favor ingrese el sufijo de la cuenta",
    sipTip:
      "Ingrese el nombre de usuario registrado y la contraseña del servidor SIP",
    password: "Por favor, introduzca su contraseña",
    passwordTitle: "contraseña",
    serverIp: "Por favor ingrese la IP del servidor",
    protocolType: "Seleccione el tipo de protocolo",
    protocolTypeTitle: "tipo de acuerdo",
    sip2: "configuración de información sip2",
    more: "Más",
    close: "cierre",
    formatError: "Error de formato, vuelva a ingresar",
    forbidTip: "Prohibido ingresar 127.0.0.1, vuelva a ingresar",
    call: "Llama y llama",
    monitor: "monitor",
    lift: "Control de ascensores",
    rtsp: "transmisión de vídeo rtsp",
    deviceTip:
      "La función de soporte del dispositivo no puede estar vacía, elija de nuevo",
    maskTip1: "La máscara de subred no puede estar vacía, vuelva a ingresar",
    maskTip2:
      "El formato de la máscara de subred es incorrecto, vuelva a ingresar",
    gatewayTip1: "La puerta de enlace no puede estar vacía, vuelva a ingresar",
    gatewayTip2: "Error de formato de puerta de enlace, vuelva a ingresar",
    ipTip1: "La dirección IP no puede estar vacía, vuelva a ingresarla",
    ipTip2:
      "Error de formato de dirección IP, el límite superior es 255.254.254.253, el primer párrafo no es 0, vuelva a ingresar",
    dns1Tip1: "DNS1 no puede estar vacío, vuelva a ingresar",
    dns1Tip2: "Error de formato DNS1, vuelva a ingresar",
    dns2Tip1: "Error de formato DNS2, vuelva a ingresar",
    passwordTip1: "La contraseña no puede estar vacía, vuelva a ingresarla",
    serviceTip1: "serviceIp no puede estar vacío, vuelva a ingresar",
    serviceTip2: "Error de formato serviceIp, vuelva a ingresar",
    sip2Tip:
      "Actualmente ha configurado la información de sip2, complétela de acuerdo con las reglas",
    devnameTip1:
      "El nombre del dispositivo no puede estar vacío, vuelva a ingresarlo",
    devnameTip2: "Error de formato de nombre de dispositivo, vuelva a ingresar",
    nameTip1: "El nombre de usuario no puede estar vacío, elija de nuevo",
    nameTip2: "El nombre de usuario no puede estar vacío, elija de nuevo",
    maxTip1:
      "La cantidad de dispositivos en el área actual ha alcanzado el límite superior de 8 y no se pueden agregar más",
    area: "área",
    editArea: "Editar Área",
    addArea: "Agregar área",
    batchArea: "Agregar lote de área",
    deleteArea: "Eliminar región",
    areaName: "Nombre del área",
    areaNo: "Número de área",
    importAddr: "Importar libreta de direcciones",
    next: "Próximo paso",
    areaTip1: "Por favor seleccione el área a editar primero",
    areaTip2: "Seleccione primero el área que desea eliminar",
    areaTip3:
      "Su área actual está vacía, no puede agregar dispositivos en lotes en este momento, agregue primero la información del área",
    noArea: "Aún no hay configuración de zona",
    error: "Excepción de datos",
    addDevice: "Añadir dispositivo",
    editDevice: "Editar dispositivo",
    delDevice: "Eliminar dispositivo",
    batchDevice: "Agregar dispositivos en lotes",
    prev: "Anterior",
    updateAddr: "Actualizar la libreta de direcciones del dispositivo",
    saveAddr: "Guardar libreta de direcciones",
    exportAddr: "Exportar libreta de direcciones",
    deleteTip: "Si eliminar el dispositivo",
    deleteTip2:
      "Actualmente seleccionado como una región, regrese a la configuración de la región para eliminar",
    deleteTip3: "Seleccione primero el dispositivo que desea eliminar",
    deviceTip1: "Seleccione primero el dispositivo que desea editar",
    deviceTip2: "Seleccione primero la región y luego agregue el dispositivo",
    exportSuccess: "Exportación exitosa",
    xmlTip: "Cargue el archivo xml de la libreta de direcciones",
    xmlTip1: "Seleccione el archivo xml para cargar",
    xmlTip2:
      "La libreta de direcciones importada es inconsistente con el nivel de comunidad actual y la importación falló",
    areaConfig: "Configuración de Área",
    deviceConfig: "Configuración del dispositivo",
    exportConfig: "Vista previa de exportación",
    projectConfig: "Configuración del proyecto",
    prevArea: "Pertenece al área superior",
    areaNoTip:
      "El número inicial es mayor que el número final, por favor complete de nuevo",
    smallAreaTip:
      "Actualmente el nivel de área más pequeño, no se pueden agregar más subáreas",
    areaNoTip1:
      "El número inicial de la primera parte es mayor que el número final de la primera parte, por favor complete nuevamente",
    areaNoTip2:
      "El número inicial de la cola es mayor que el número final de la cola, rellénelo de nuevo",
  },
  push: {
    list: "Empujar Grabar",
    productType: "Número de producto",
    softwareName: "nombre del software",
    versionNo: "número de versión",
    time: "Tiempo de empuje",
    invalidTime: "Tiempo de expiración",
    upgrade: "mejora",
    upgradeRecord: "Ver registro de actualización",
    deviceType: "Tipo de equipo",
    deviceName: "Nombre del dispositivo",
    currentSoftName: "Nombre actual del software del dispositivo",
    currentSoftNo: "Número de versión actual del dispositivo",
    upgradeNo: "Número de versión del software de actualización",
    filterTip1: "Por favor ingrese el nombre del dispositivo",
    filterTip2: "Seleccione el nombre del software",
    filterTip3: "Seleccione un número de versión",
    checkTip: "Activar Tick",
    ota: "Actualización OTA",
    taskName: "nombre de la misión",
    taskNameTip: "Por favor ingrese un nombre de tarea",
    binName: "Nombre del firmware",
    upgradeType: "Método de actualización de tareas",
    done: "Ya sea para ejecutar inmediatamente",
    upgradeTime: "tiempo de actualización",
  },
  check: {
    submit: "¡Felicitaciones, la presentación fue exitosa!",
    noSubmit: "¡Vaya, el envío falló!",
    file: "Seleccione un documento",
    noFile: "Ningún archivo seleccionado",
    projectName: "nombre del proyecto",
    projectNameTip: "Por favor ingrese un nombre de proyecto",
    describe: "describir",
    contentTip: "Por favor ingrese el contenido",
    areaType: "Jerarquía de regiones",
    example: "Por ejemplo: número de habitación de la unidad de edificio",
    areaTip: "El formato del número de área es incorrecto, vuelva a ingresarlo",
    areaNameTip: "Por favor ingrese un nombre de capa",
    nameTip: "El nombre no puede estar vacío, vuelva a ingresar",
    nameError: "El nombre se ingresó incorrectamente, vuelva a ingresarlo",
    nameLength:
      "La longitud de entrada del nombre es 4 ~ 50, vuelva a ingresar",
    areaNullTip: "El nivel de área no puede estar vacío",
    formateError:
      "La longitud es de 1 a 6 dígitos, no se pueden ingresar símbolos especiales",
    noAreaTip: "El nivel del área no puede estar vacío, seleccione de nuevo",
    maxFileTip: "El tamaño del archivo supera el límite",
    xmlTip: "Cargue un archivo en formato XML",
  },
  book: {
    areaBy: "Región",
    list: "Lista de duplicados de información del dispositivo",
    repeatTip:
      "La siguiente información del equipo está duplicada. Modifique la información del equipo duplicado. Después de hacer clic en  Confirmar,juzgará la duplicación de la información de entrada del equipo ",
    coverTip:
      "Esta operación sobrescribirá el lote agregando datos del nivel actualmente seleccionado",
    batchTip: "El rango de IP generado al agregar dispositivos en lotes",
  },
  updateNewSip: {
    otaDeleteTip:
      "Error al eliminar, solo se pueden eliminar las tareas no iniciadas",
    deleteArea1: "Si eliminar la región",
    deleteArea2:
      "Al mismo tiempo, todas las áreas y dispositivos debajo de esta área se eliminarán juntos",
    codeRepeatTip:
      "La ID de región del mismo nivel no se puede repetir, vuelva a ingresar la ID de región actual",
    nameRepeatTip:
      "Los nombres de área en el mismo nivel no se pueden duplicar, vuelva a ingresar el nombre de la región actual",
    deviceIp: "IP del dispositivo",
    callin: "Llamar",
    callout: "exhalar",
    systemMsg: "información del sistema",
    batchIpTip:
      "El rango de IP generado al agregar dispositivos en lotes esta vez",
    ip: "Dirección IP",
    mask: "Máscara de subred",
    gateway: "Puerta",
    noData: "No",
    noAddressTip:
      "Actualmente no hay datos de la libreta de direcciones que se puedan sincronizar",
    operator: "Operador",
    goTip: "Haga clic para saltar al paso correspondiente",
    deviceNameTip:
      "La longitud de entrada es de 1 a 16 dígitos, no se pueden ingresar símbolos especiales",
    filter1: "Ingrese un nombre de área para filtrar",
    filter2:
      "Ingrese el nombre del área o el nombre del dispositivo para filtrar",
    secret: "Contraseña de cifrado",
    secretTip:
      "Por favor ingrese una contraseña de 32 caracteres, el formato no está limitado",
    noSecretTip: "La contraseña de cifrado no establecida se puede ignorar",
    setSecret: "Establecer contraseña de cifrado de la libreta de direcciones",
    ignore: "descuido",
    emptyBookTip:
      "La libreta de direcciones está vacía y no se puede exportar temporalmente",
    errorSecret:
      "Error de contraseña de cifrado de la libreta de direcciones, vuelva a introducirla",
    other: "otro",
    doorAuth: "Control de acceso",
    funTitle:
      "Verifique las funciones compatibles con el dispositivo que agregó",
    callInTip: "Llamada de soporte del dispositivo",
    callOutTip: "Se llama soporte de dispositivo",
    monitorTip: "El dispositivo admite ser monitoreado",
    doorTip: "El dispositivo admite la función de desbloqueo",
    liftTip: "Ascensor de control de soporte de dispositivo",
    maskTip:
      "Ingrese la máscara de subred, referencia de formato: 255.255.255.255",
    gatewayTip: "Ingrese la puerta de enlace, referencia de formato: 1.1.1.1",
    ip1: "Por favor ingrese la dirección IP, formato de referencia: 1.1.1.1",
    ipTip:
      "La dirección IP de entrada debe evitar una IP especial, como 127.0.0.1, etc.",
    dns1: "Ingrese DNS1, referencia de formato: 1.1.1.1",
    dns2: "Ingrese DNS2, referencia de formato: 1.1.1.1",
    serverIp:
      "Ingrese serverIp, referencia de formato: 1.1.1.1 o nombre de dominio",
    successxml: "Archivo analizado con éxito",
    groupCall: "llamada de grupo",
    groupCallTip:
      "Después de encenderlo, puede llamar a todos los dispositivos del grupo haciendo clic en el ícono de llamada grupal",
    record: "registro de versión",
    export: "exportar",
    sync: "Sincronizar",
    communityTip:
      "Actualmente hay datos de dispositivos de área, está prohibido cambiar el nivel de área",
    areaNameTitle: "Descripción de la jerarquía",
    noDataTip: "no hay datos por el momento",
    areaCodeDescriptionTip:
      "la descripción del área no puede estar vacía, por favor complete",
    moduleName: "Herramienta de configuración de la libreta de direcciones",
    userSipAccount:
      "Fijo como el número de área del grupo superior al que pertenece + número de serie del equipo",
    devMax:
      "El nodo de dispositivo superó el límite de 10000 entradas, no se pudo añadir",
    areaMax:
      "Nodo de área excedió el límite de 10000 entradas, falló al agregar",
    ipAndMaskTip1:
      "La dirección IP está asociada con la máscara de subred y debe cumplir con la validación lógica del negocio de tener resultados con todos 1 o todos 0 después de la operación AND a nivel de bits.",
    ipAndMaskTip2:
      "Si ocurre un error en la regla de validación del negocio, por favor modifique la dirección IP correspondiente.",
    ipAndMaskTip3:
      "Las reglas de validación del negocio de la máscara de subred y la dirección IP son incorrectas. Por favor modifique la dirección IP.",
    ipAndMaskTip4:
      "Al agregar dispositivos en lotes, las IPs que no cumplen con la validación lógica del negocio se omitirán automáticamente.",
    correctMaskTip: "Por favor complete primero la máscara de subred correcta.",
    correctIpTip: "Por favor ingrese la dirección IP correcta.",
  },
  newDeviceType: {
    indoorMachine: "Unidad interior",
    doorPhone: "Intercomunicador de la puerta",
    smallDoor: "Intercomunicador de la puerta pequeño",
    manage: "Dispositivo de gestión",
    wall: "Dispositivo de pared",
    monitor: "Cámara IP",
    unitGuard: "Dispositivo de gestión de la unidad",
    networkCard: "Lector de tarjetas de red",
    unitCard: "Lector de tarjetas de la unidad",
    lift: "Módulo de interacción con el ascensor",
    deviceTypeTip: "Por favor, seleccione el tipo de dispositivo"
    }
};
